import { module } from 'modujs';

export default class extends module {
  constructor(m) {
    super(m);
  }

  init() {
    this.DOM = {
      view: this.el,
    };
    this.VARS = {
      MERCHANT_ID: 'merchant_11vhFx9kq9qYjwiA7fTMV3AceLpG6LjFiC',
      NUMBER_OF_COUNT: 3,
      MIN_AMOUNT: 10000,
      MAX_AMOUNT: 150000,
    };
    this.widgets = Alma.Widgets.initialize(
      this.VARS.MERCHANT_ID,
      Alma.ApiMode.TEST // mode de l'API (LIVE ou TEST)
    );
    this.mount();
    this.events();
  }

  events() {
    this.DOM.view.addEventListener('click', () => {
      this.mount();
      this.modal.open();
    });
  }

  mount() {
    this.modal = this.widgets.add(Alma.Widgets.Modal, {
      container: '#alma-widget-modal',
      purchaseAmount: this.$('input')[0].value,
      locale: Shopify.locale,
      plans: [
        {
          installmentsCount: this.VARS.NUMBER_OF_COUNT,
          minAmount: this.VARS.MIN_AMOUNT,
          maxAmount: this.VARS.MAX_AMOUNT,
        },
      ],
    });
  }
}
